import { inject, NgModule } from '@angular/core';
import { ActivatedRouteSnapshot, RouterModule, RouterStateSnapshot, Routes } from '@angular/router';
import { map } from 'rxjs';
import { AdminLayoutComponent } from './@theme/shared/components/layouts/admin-layout/admin-layout.component';
import { AuthLayoutComponent } from './@theme/shared/components/layouts/auth-layout/auth-layout.component';
import { AccessDeniedComponent } from './auth/access-denied/access-denied.component';
import { AuthCallbackComponent } from './auth/auth-callback/auth-callback.component';
import { AppLoginComponent } from './auth/login/login.component';
import { AccessRightsService } from './core/access-rights/access-right.service';
import { authGuard } from './core/auth/guard/activate-auth.guard';
import { AppNavigationService } from './core/navigation/app-navigation.service';
import { HomeComponent } from './home/home.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'pages/guide/list',
    pathMatch: 'full'
  },
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: 'login',
        component: AppLoginComponent
      },
      {
        path: 'auth-callback',
        component: AuthCallbackComponent
      },
      {
        path: 'access-denied',
        component: AccessDeniedComponent
      },
      {
        path: '',
        loadChildren: () => import('./privacy/privacy.module').then(m => m.PrivacyModule),
      }
    ]
  },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivateChild: [authGuard],
    resolve: {
      // load access-rights before loading any child route
      ['access-rights']: (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
        const accessRightsService = inject(AccessRightsService);
        const appNavigationService = inject(AppNavigationService);

        return accessRightsService.ensureHasAccessRights().pipe(
          map(r => {
            if (!r) {
              appNavigationService.goToAccessDenied();
            }
          })
        );
      }
    },
    children: [
      {
        path: 'pages',
        loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule),
        data: { title: 'Pages' }
      },
      { path: 'home', component: HomeComponent },
    ]
  },
  { path: '**', redirectTo: '/pages/guide/list' }, // Default route
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
